import {
  findColorShade10,
  findColorShade20,
  findColorShade30,
  findColorShade40,
  findColorShade50,
  PaletteColorShadeFinder,
} from '../themeColorHelpers';

export interface TagSemanticStyles {
  findColor: PaletteColorShadeFinder;
  findHoverColor: PaletteColorShadeFinder;
  findBackgroundColor: PaletteColorShadeFinder;
  findHoverBackgroundColor: PaletteColorShadeFinder;
  findBorderColor: PaletteColorShadeFinder;
  findHoverBorderColor: PaletteColorShadeFinder;
}

export const lightTagSemanticStyles = {
  findColor: findColorShade40,
  findHoverColor: findColorShade40,

  findBackgroundColor: findColorShade10,
  findHoverBackgroundColor: findColorShade20,

  findBorderColor: findColorShade40,
  findHoverBorderColor: findColorShade50,
} as const satisfies TagSemanticStyles;

export const darkTagSemanticStyles = {
  findColor: findColorShade50,
  findHoverColor: findColorShade50,

  findBackgroundColor: findColorShade10,
  findHoverBackgroundColor: findColorShade20,

  findBorderColor: findColorShade30,
  findHoverBorderColor: findColorShade40,
} as const satisfies TagSemanticStyles;
